import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Utensils, Clock, CheckCircle2, Calendar, Gift } from 'lucide-react';
import { useCart } from '../context/CartContext';
const features = [{
  icon: BookOpen,
  text: '100 recetas argentinas adaptadas para Air Fryer'
}, {
  icon: Utensils,
  text: 'Desayunos, platos principales, postres y más'
}, {
  icon: Clock,
  text: 'Tiempos y temperaturas exactas en cada receta'
}, {
  icon: CheckCircle2,
  text: 'Compatible con todas las marcas (Philips, Atma, Essen, Liliana...)'
}, {
  icon: Calendar,
  text: 'Plan de comidas saludables de 30 dias'
}, {
  icon: Gift,
  text: 'eBooks de regalo incluidos automáticamente'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatsIncludedSection() {
  const {
    setCartOpen
  } = useCart();
  return <section className="w-full py-12 md:py-20 px-6 bg-background" data-id="element-450">
      <div className="max-w-[900px] mx-auto" data-id="element-451">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-3xl md:text-4xl font-serif mb-12 text-center text-charcoal" data-id="element-452">
          Todo lo que recibís con tu compra
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-453">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="bg-white border border-surface rounded-2xl p-6 shadow-soft flex items-start gap-4" data-id="element-454">
              <div className="text-primary mt-1 flex-shrink-0" data-id="element-455">
                <feature.icon className="w-6 h-6" strokeWidth={2} data-id="element-456" />
              </div>
              <p className="text-base md:text-lg text-charcoal font-medium leading-snug" data-id="element-457">
                {feature.text}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-10 text-center" data-id="element-458">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => setCartOpen(true)} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-10 rounded-xl shadow-soft transition-colors text-lg" data-id="element-459">
            Descargar ahora →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}